// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"884dbe731b6e646b153b","461":"44f76bd5c9633fbf31ba","882":"4e1a9c5aefe8ac62bc45","997":"f19d402372b76cbd7e13"}[chunkId] + ".chunk.js";
};